import logger from '../../../../services/logging/logging-service';
import {
  latestNewsInfiniteActions as actions,
  latestNewsInfiniteStore as store,
} from '../../../../global-store/subjects/latest-news/latest-news-infinite';

const FOOTER_DISTANCE = 300;

export const initInfiniteScroll = () => {
  const $footer = document.querySelector('.c-footer');
  const options = {
    rootMargin: `0px 0px ${$footer.scrollHeight + FOOTER_DISTANCE}px 0px`,
    threshold: 1.0,
  };
  const callback = async (entries, observer) => {
    const entry = entries[0];
    const { isLoadingInfinite, nextPagePath } = store.getValue();
    if (entry.isIntersecting && !isLoadingInfinite) {
      try {
        actions.setQueryStart(true);
        // const response = await fetch(lastJson.nextPagePath);
        const response = await fetch(nextPagePath);
        const newData = await response.json();
        if (newData.cardList.length) {
          actions.setQuerySuccess(newData);
        } else {
          actions.setQueryFailure();
          observer.unobserve();
        }
      } catch (error) {
        actions.setQueryFailure();
        observer.unobserve();
        logger.warn('initInfiniteScroll error', error);
      }
    }
  };
  const observer = new IntersectionObserver(callback, options);
  observer.observe($footer);
};
